import script from "./LocationSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationSearch.vue?vue&type=script&setup=true&lang=ts"

import "./LocationSearch.vue?vue&type=style&index=0&id=049c9a1e&lang=less"

const __exports__ = script;

export default __exports__